/**
 * Bhai Dooj cards — authored via the `/pack` toile process (plan
 * `thinking/plans/2026_08_31_toile_pack_wiring.md` Track B), wave `toile_diwali`. Narcis file-split
 * shape (Track A): one module per pack, `registry.ts` assembles them into `livePacks`.
 */
import {tagline, chips, type ToilePack} from './data'

export const bhaiDoojCardsPack: ToilePack = {
    slug: 'bhai-dooj-cards',
    category: 'faith',
    name: 'Bhai Dooj cards',
    tagline: tagline('pieces', 'themes', 'styles'),
    chips: chips('themes', 'styles'),
    ratio: {w: 832, h: 1216},
    readings: [
        {key: 'tilak', label: 'Tilak thali', subject: 'a card headed "Happy Bhai Dooj" with a thali of roli, rice and a lit diya at the top and an empty message panel below'},
        {key: 'phonta', label: 'Bhai Phonta', subject: 'a card headed "Bhai Phonta" with a sandalwood-paste mark on a leaf, a conch and a small bowl of sweets, and an empty message panel'},
        {key: 'kids', label: 'For a little brother', subject: 'a bright card headed "Best Brother" with a smiling diya and two kites, a blank line at the bottom for the sister\'s name'},
    ],
    styles: [
        {key: 'watercolor', label: 'Watercolor', style: 'soft watercolor illustration, loose edges, hand-lettered heading', palette: 'marigold, rose and leaf green washes on white paper', framing: 'Centered on the card with a wide white margin'},
        {key: 'flat', label: 'Flat color', style: 'flat vector illustration, bold clean shapes, smooth gradient-free fills, crisp lettering', palette: 'orange, deep pink, teal and cream, a limited palette', framing: 'Full card on a solid cream ground with the empty panel in the lower half'},
        {key: 'papercut', label: 'Paper cut', style: 'layered paper-cut look, soft drop shadow between layers, scalloped edges', palette: 'deep red, gold and ivory paper layers', framing: 'Layered artwork centered with an ivory margin'},
    ],
    directions: ['Big brother', 'Blue', 'Twin kites'],
    directionHint: 'try: Big brother',
    seo: {
        title: 'Bhai Dooj cards: tilak thali, Bhai Phonta, little brother',
        metaDescription: 'Printable Bhai Dooj cards from a sister to her brother, with a lettered greeting and a blank message panel, in three card styles.',
        h1: 'Bhai Dooj cards: tilak thali, Bhai Phonta, for a little brother',
        tagline: 'Nine printable cards, each with its greeting lettered exactly and a blank panel for a message.',
        intro: 'The card a sister gives her brother on Bhai Dooj, the last day of Diwali. The day is Bhau Beej in Maharashtra, Bhai Phonta in Bengal and Bhai Tika in Nepal. Each card has its greeting lettered exactly, such as Happy Bhai Dooj, Bhai Phonta or Best Brother, and a blank panel for a message. The styles are soft watercolour, flat colour and layered paper cut.',
        useCases: [
            'a card from a sister to her brother',
            'a card for a little brother',
            'a Bhai Dooj greeting for a family',
            'a card with space for a handwritten message',
        ],
        faq: [
            {q: 'What is the day called?', a: 'Bhai Dooj in most places, Bhau Beej in Maharashtra, Bhai Phonta in Bengal and Bhai Tika in Nepal.'},
            {q: 'Is there room for a message?', a: 'Yes. Each card has a blank panel for a handwritten message.'},
            {q: 'What is on the tilak thali card?', a: 'A thali of roli and rice with a lit diya at the top, and an empty message panel below.'},
            {q: 'Can I ask for a different greeting?', a: 'Yes. The direction field takes a change such as Big brother, Blue or Twin kites. A direction you type is a request, not a promised result.'},
        ],
    },
}
